module.exports = __webpack_public_path__ + "img/a4.2a626ae1.jpg";